import React from 'react';
import { Collapse } from 'reactstrap';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { ReactComponent as ArrowIcon } from 'assets/img/icons/new/collapse-right-arrow.svg';

/**
 * @param {Object} props
 * @param {import('./types').Option[]} props.list
 * @param {Record<string, boolean>} props.value
 * @param {(id: string, checked: boolean) => void} props.onChange
 * @param {boolean} props.isDisabled
 * @param {Record<string, boolean>} props.openMap
 * @param {(id: string) => void} props.onToggle
 * @param {string} props.className
 */
export default function Options({
  list = [],
  value = {},
  onChange = () => {},
  isDisabled = false,
  openMap = {},
  onToggle = () => {},
  className = ''
}) {
  const checkboxes = list.map(
    ({ id, label, disabled, indeterminate, options, tooltipText }) => {
      const checked = _get(value, id, false);
      const hasSubOptions = !_isEmpty(options);
      const isOpen = _get(openMap, id, false);
      return (
        <UiKit.Checkbox
          key={id}
          label={label}
          tooltipText={tooltipText}
          checked={checked}
          onChange={value => onChange(id, value)}
          disabled={disabled || isDisabled}
          indeterminate={indeterminate}
          contentGap="0"
        >
          <If test={hasSubOptions}>
            <UiKit.Button
              variant="ghost"
              className={styles.arrowBtn}
              data-open={isOpen}
              onClick={() => onToggle(id)}
            >
              <ArrowIcon className={styles.arrow} />
            </UiKit.Button>
            <Collapse isOpen={isOpen} className={styles.collapse}>
              <Options
                list={options}
                value={value}
                onChange={onChange}
                isDisabled={isDisabled}
                openMap={openMap}
                onToggle={onToggle}
                className="pt-2"
              />
            </Collapse>
          </If>
        </UiKit.Checkbox>
      );
    }
  );

  if (_isEmpty(checkboxes)) return null;

  return (
    <UiKit.Grid templateColumns="1fr" gap="8" className={className}>
      {checkboxes}
    </UiKit.Grid>
  );
}
